<template>
  <div>
    <TableList
      :columns="tabPaneConfig[tabKey - 1].columns"
      :tableData="tabPaneConfig[tabKey - 1].tableData"
      :loading="tabPaneConfig[tabKey - 1].loading"
      :scroll="false"
      :pagination="tabPaneConfig[tabKey - 1].pagination"
      @change="handleTableChange"
    >
      <div slot="queryArea" class="query-area">
        <div>
          <j-dict-select-tag
            style="width: 170px; margin-right: 15px"
            placeholder="请选择年级"
            v-model="queryParam.gradeId"
            dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
            :isShowEmpty="false"
          />
          <a-input-search
            v-model="queryParam.studentName"
            placeholder="请输入学生名字"
            class="search-space"
            style="width: 170px"
            @change="searchName"
          />
          <a-button type="primary" @click="queryTable">查询</a-button>
        </div>
      </div>
      <template slot="action" slot-scope="{ record }">
        <div class="action-detail">
          <span @click="idoneIt(record)" :style="{ opacity: record.status == 3 ? 0.5 : 1 }">
            我已完成
          </span>
          <a-divider type="vertical" />
          <span @click="viewContent(record)">查看详情</span>
        </div>
      </template>
    </TableList>
    <DetailContent ref="detailContentRef" />
  </div>
</template>
<script>
import TableList from '@comp/chart/TableList.vue'
import { getAction, putAction } from '@api/manage'
import { simpleDebounce } from '@/utils/util'
import AssessModal from '@/comUi/AssessModal.vue'
import DetailContent from './components/DetailContent.vue'
import moment from 'moment'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

const tablePagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

export default {
  name: 'ClassMoodDetail',
  components: {
    TableList,
    AssessModal,
    DetailContent,
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      tabKey: 1,
      queryParam: {},
      dateRange: [],
      tabPaneConfig: [
        {
          tab: '',
          key: 1,
          columns: [
            {
              title: '序号',
              dataIndex: 'index',
              align: 'center',
            },
            {
              title: '活动名称',
              dataIndex: 'title',
              align: 'center',
            },
            {
              title: '活动时间',
              dataIndex: 'beginDate',
              align: 'center',
              customRender: (_, record) => {
                return record.beginDate ? record.beginDate + ' 至 ' + record.endDate : '-'
              },
            },
            {
              title: '活动内容',
              dataIndex: 'content',
              align: 'center',
              customRender: (_, record) => {
                return record.content.length >= 25 ? (
                  <a-tooltip>
                    <template slot="title">{record.content}</template>
                    {record.content.substring(0, 25) + '...'}
                  </a-tooltip>
                ) : (
                  record.content
                )
              },
            },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
      ],
      url: {
        list: '/schoolActivityPlan/list',
        exportXlsUrl: '/aigoes/schoolWarnRecord/crisisInterventionExport',
      },
      detailModalData: [],
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    handleTabChange(key) {
      this.tabKey = key
      this.queryParam = {}
      this.detailModalData = []
      this.loadData()
    },
    onRangeChange() {},
    // 分页变化
    handleTableChange(page) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', page)
      this.loadData()
    },
    // 查询
    queryTable() {
      console.log('查询条件--', this.queryParam)
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', { ...tablePagination })
      this.loadData()
    },
    searchName: simpleDebounce(function (event) {
      console.log('搜索条件--', event.target.value)
      const name = event.target.value
      this.getTableData()
    }, 500),
    loadData() {
      switch (this.tabKey) {
        case 1:
          this.$set(this.url, 'list', '/schoolActivityPlan/list')
          break
      }
      this.getTableData()
      // this.queryParam = {}
    },
    getTableData() {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', true)
      const params = {
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
        ...this.queryParam,
        beginDate: this.dateRange[0] && moment(this.dateRange[0]).format('YYYY-MM-DD'),
        endDate: this.dateRange[1] && moment(this.dateRange[1]).format('YYYY-MM-DD'),
      }
      getAction(this.url.list, params)
        .then((res) => {
          console.log('获取列表数据--', res)
          if (res.success) {
            const tableData = res.result.records.length
              ? res.result.records.map((item, index) => ({
                  ...item,
                  index: index + 1,
                }))
              : []
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'tableData', tableData)
            this.$set(this.tabPaneConfig[this.tabKey - 1].pagination, 'total', res.result.total)
          }
        })
        .finally(() => {
          this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
        })
    },
    async idoneIt(record) {
      const res = await putAction('/schoolActivityPlan/edit', { id: record.id, status: 3 })
      if (res.success) {
        this.$message.success(res.message || '操作成功')
        this.loadData()
      } else {
        this.$message.error(res.message || '操作失败')
      }
    },
    viewContent(record) {
      this.$refs.detailContentRef.showModal(record)
    },
  },
}
</script>
<style scoped lang="less">
.query-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}
.action-detail {
  min-width: 100px !important;
  color: #1783e8 !important;
  cursor: pointer !important;
}
.search-space {
  width: 140px;
  margin-right: 15px;
}
</style>
